import { FlexCol, FlexRow } from "src/utils/flexLayouts";

import {
  BarElement,
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  ChartOptions,
  Legend,
  LinearScale,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import React, { ReactNode } from "react";
import { Bar } from "react-chartjs-2";
import { twMerge } from "tailwind-merge";

function BarChartComponent({
  title,
  data,
  options,
}: {
  title: ReactNode;
  data: ChartData<"bar", number[], string>;
  options?: ChartOptions<"bar">;
}) {
  return (
    <FlexCol className="relative w-full">
      <FlexRow className="px-6 py-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-thumb-[#D1D5DB]">
        <FlexCol
          style={{ minWidth: (data.labels && data.labels.length > 7 && `${data.labels.length * 160}px`) || "auto" }}
          className={twMerge("w-full relative")}
        >
          <FlexRow className="items-center justify-center pb-5 space-x-4">{title}</FlexRow>

          <div className="h-[557px]">
            <BarChart data={data} options={options} />
          </div>
        </FlexCol>
      </FlexRow>
    </FlexCol>
  );
}

export default BarChartComponent;

// Регистрация компонентов Chart.js
ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, ChartDataLabels);

// Типизация для пропсов
interface BarChartProps {
  data: ChartData<"bar", number[], string>;
  options?: ChartOptions<"bar">;
}

const BarChart: React.FC<BarChartProps> = ({
  data,
  options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 8, // Size of the color box (rectangle)
          boxHeight: 8, // Height of the color box
          padding: 20, // Spacing between legend items
        },
      },
      tooltip: {
        callbacks: {
          label: (tooltipItem: any) => {
            return ` ${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
          },
        },
      },
      datalabels: {
        display: false,
      },
    },
    scales: {
      x: {
        grid: {
          display: false, // Убирает сетку, чтобы это не влияло визуально
        },
      },
      y: {
        beginAtZero: true,
        max: 100, // Устанавливаем максимальное значение оси Y
        ticks: {
          stepSize: 10, // Шаг шкалы кратен 10
          callback: (value: any) => `${value}`, // Отображение значений (например, можно добавить единицы измерения)
        },
      },
    },
  },
}) => {
  return <Bar data={data} options={options} />;
};
